// components/StockTables/SalesStockTable.jsx
import React from 'react';

const SalesStockTable = ({ data }) => {
  // const dataforSale = _.filter(
  //   data[0]?.summary,
  //   (row) => row?.gold_transaction_type === 'SALE',
  // );

  const TableHeader = () => (
    <thead className="bg-green-600">
      <tr>
        <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-green-500">
          รายการสินค้า
        </th>
        <th className="px-4 py-3 text-center text-sm font-bold text-white border-r border-green-500">
          ประเภท
        </th>
        {data?.materials?.some((item) => item?.place !== 'คลังอื่นๆ') ? (
          <th className="px-4 py-3 text-center text-sm font-bold text-white border-r border-green-500">
            น้ำหนัก
          </th>
        ) : (
          <th className="px-4 py-3 text-center text-sm font-bold text-white border-r border-green-500">
            ชิ้น
          </th>
        )}
        <th className="px-4 py-3 text-center text-sm font-bold text-white">
          มูลค่าขายก่อนภาษี
        </th>
        <th className="px-4 py-3 text-center text-sm font-bold text-white border-r border-green-500">
          ภาษี VAT
        </th>
        <th className="px-4 py-3 text-center text-sm font-bold text-white border-r border-green-500">
          มูลค่าเฉลี่ย
        </th>
        <th className="px-4 py-3 text-center text-sm font-bold text-white">
          มูลค่าขายรวมภาษี
        </th>
      </tr>
    </thead>
  );

  const TableRows = ({ materials }) => (
    <tbody>
      {_.chain(materials)
        .sortBy((item) => {
          // อัปเดต: ใช้ 'product_type' สำหรับการเรียงลำดับ
          const productTypeName = item?.product_type || '';
          return productTypeName === '96.5%' ? '0' : `1_${productTypeName}`;
        })
        // อัปเดต: ใช้ 'product_name' และ 'product_type' ในการจัดกลุ่มข้อมูล
        .groupBy((item) => item.product_name + (item.product_type || ''))
        .map((group) => {
          // คำนวณค่ารวมจากฟิลด์ที่ถูกต้อง

          const sumWeight = _.sumBy(group, (g) => Number(g?.totalWeight) || 0);
          const sumCostbeforeVat = _.sumBy(
            group,
            // อัปเดต: แก้ไขชื่อฟิลด์เป็น totalBeforeVat (ตัว B ใหญ่)
            (g) => Number(g?.totalBeforeVat) || 0,
          );
          const sumCost = _.sumBy(group, (g) => Number(g.totalCost) || 0);
          const sumVat = _.sumBy(group, (g) => Number(g.totalVat) || 0);
          // อัปเดต: ใช้ 'totalValue' สำหรับยอดรวมทั้งหมด (รวมภาษี)
          const sumTotalValue = _.sumBy(
            group,
            (g) => Number(g?.totalValue) || 0,
          );

          const item = group[0];
          // อัปเดต: แก้ไขเงื่อนไขการคำนวณค่าเฉลี่ย
          const averageCost =
            sumWeight > 0 // ป้องกันการหารด้วยศูนย์
              ? item?.product_type === 'ทองแท่ง' // ใช้ 'product_type'
                ? (sumCostbeforeVat / sumWeight) * 15.244
                : (sumCostbeforeVat / sumWeight) * 15.16
              : 0;

          // totalcost คือยอดรวมทั้งหมดจาก totalValue
          const totalcost = sumTotalValue;

          return (
            // อัปเดต: key ของ tr ให้ไม่ซ้ำกัน
            <tr key={item?.product_name + (item?.product_type || '')}>
              <td className="px-4 py-2 text-sm text-gray-800 border-r border-gray-200">
                {/* อัปเดต: แสดงผล 'product_name' */}
                {item?.product_name || '-'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {/* อัปเดต: แสดงผล 'product_type' */}
                {item?.product_type || '-'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {item?.isbar ||
                ['ทองคำแท่ง', 'ทองแท่ง'].includes(item?.product_name)
                  ? sumWeight?.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    }) || '-'
                  : sumWeight?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) || '-'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {sumCostbeforeVat
                  ? Number(sumCostbeforeVat.toFixed(2)).toLocaleString()
                  : '-'}
              </td>

              {/* ส่วนที่คอมเมนต์ไว้ยังคงเดิม */}
              {/* <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {sumCostbeforeVat
                  ? Number(sumCostbeforeVat).toLocaleString()
                  : '-'}
              </td> */}
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {sumVat ? Number(sumVat).toLocaleString() : '-'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {averageCost ? Number(averageCost).toLocaleString() : '-'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {totalcost
                  ? Number(totalcost.toFixed(2)).toLocaleString()
                  : '-'}
              </td>
            </tr>
          );
        })
        .value()}
    </tbody>
  );

  return (
    <div className="space-y-6">
      {_.chain(data?.materials || [])
        .groupBy('place')
        .toPairs()
        .sortBy(([place]) =>
          place === 'คลังรูปพรรณใหม่' ? '0' : `1_${place || 'zzz'}`,
        )
        .map(([place, materials]) => (
          <div
            key={place}
            className="bg-white rounded-lg shadow-sm overflow-hidden"
          >
            <div className="bg-gray-50 px-4 py-2 border-b">
              <h3 className="text-lg font-semibold text-gray-800">
                {place || 'ไม่ระบุคลัง'}
              </h3>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full">
                <TableHeader />
                <TableRows materials={materials} />
              </table>
            </div>
          </div>
        ))
        .value()}
    </div>
  );
};

export default SalesStockTable;
